export function getTags(state, props) {
  return state.data.tags
}
